import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IReferralResponseModel } from "../models/IReferral";

export class ReferralResponseApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    rejectReferral(referralResponse: IReferralResponseModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/response/reject`, referralResponse, success, error, final);
    }

    complementReferral(referralResponse: IReferralResponseModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/response/complement`, referralResponse, success, error, final);
    }

    approveReferral(referralId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/response/approve/${referralId}`, null, success, error, final);
    }

    closeReferral(data: IReferralResponseModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/response/close`, data, success, error, final);
    }

    saveReferralAnswer(data: IReferralResponseModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/referral/response/saveReferralAnswer`, data, success, error, final);
    }

    
}

